import axiosInstance from './axiosInstance';

async function geocodeByPlaceId(placeId) {
  const res = await axiosInstance.get('search/maps/geocode/place', {
    params: { placeId },
  });
  return res?.data?.results || [];
}

async function geocodeByAddress(address) {
  const res = await axiosInstance.get('search/maps/geocode/address', {
    params: { address },
  });
  return res?.data?.results || [];
}

function getLatLng(result) {
  const location = result?.geometry?.location;
  if (!location) {
    throw new Error('Location not found');
  }
  return {
    lat: typeof location.lat === 'function' ? location.lat() : location.lat,
    lng: typeof location.lng === 'function' ? location.lng() : location.lng,
  };
}

export function getDetailsFromPlaceID(placeID) {
  return geocodeByPlaceId(placeID).catch((e) => {
    throw e;
  });
}

export function getLatLngfromPlaceId(placeId) {
  return geocodeByPlaceId(placeId)
    .then((results) => getLatLng(results[0]))
    .catch((e) => {
      throw e;
    });
}

export function getLatLngByAddress(address) {
  return geocodeByAddress(address)
    .then((results) => getLatLng(results[0]))
    .catch((error) => {
      throw error;
    });
}
